import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../lib/auth';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
export function LoginPage() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const {
    login
  } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/admin';
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setTimeout(() => {
      const success = login(password);
      if (success) {
        navigate(from, {
          replace: true
        });
      } else {
        setError('Invalid password. Please try again.');
        setIsLoading(false);
      }
    }, 600); // Artificial delay for better UX
  };
  return <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6" data-id="element-1303">
      <div className="w-full max-w-sm border border-border bg-card p-8 shadow-2xl" data-id="element-1304">
        <div className="text-center mb-8" data-id="element-1305">
          <h1 className="font-display text-3xl font-bold tracking-tight text-foreground" data-id="element-1306">
            SINKA<span className="text-primary" data-id="element-1307">.</span> CMS
          </h1>
          <p className="font-mono text-[10px] text-muted-foreground uppercase tracking-widest mt-2" data-id="element-1308">
            Admin access only
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6" data-id="element-1309">
          <Input type="password" label="Password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter admin password" error={error} autoFocus data-id="element-1310" />

          <Button type="submit" className="w-full" disabled={isLoading || !password} data-id="element-1311">
            {isLoading ? 'Authenticating...' : 'Login'}
          </Button>
        </form>
      </div>
    </div>;
}